import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetChildSearchResultsQuery } from '@/services/child-api';
import Page from '@/components/page';
import PageTitle from '@/components/page-title';
import SearchPanel from './search-panel';
import SearchResults from './search-results';

const breadcrumb = [{ path: '/child', label: 'Children' }, 'Search'];

const ChildSeachPage = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const searchId = queryParams.get('q');
  const pageNumber = queryParams.get('page') || 1;
  const { data, isFetching } = useGetChildSearchResultsQuery({ searchId, pageNumber }, { skip: !searchId });
  const [results, setResults] = useState();

  useEffect(() => {
    if (!searchId) setResults();
  }, [searchId]);

  useEffect(() => {
    setResults(data);
  }, [data]);

  return (
    <Page breadcrumb={breadcrumb} size="xl">
      <PageTitle label="Children Search" />
      <SearchPanel params={results?.criteria} />
      <SearchResults searchId={searchId} data={results} loading={isFetching} />
    </Page>
  );
};

export default ChildSeachPage;
